import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RecommendedInfluencer = ({ influencer }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start gap-3 mb-4">
        <Image
          src={influencer?.avatar}
          alt={influencer?.avatarAlt}
          className="w-12 h-12 rounded-full object-cover"
        />
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground mb-1 truncate">
            {influencer?.name}
          </h4>
          <p className="text-xs text-muted-foreground mb-2">{influencer?.category}</p>
          <div className="flex items-center gap-3 text-xs text-muted-foreground">
            <div className="flex items-center gap-1">
              <Icon name="Users" size={12} />
              <span>{influencer?.followers}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="TrendingUp" size={12} />
              <span>{influencer?.engagement}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 mb-3">
        {influencer?.platforms?.map((platform, index) => (
          <div
            key={index}
            className="flex items-center gap-1 px-2 py-1 bg-muted rounded-md text-xs"
          >
            <Icon name={platform?.icon} size={12} />
            <span className="text-muted-foreground">{platform?.name}</span>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs text-muted-foreground">Başlangıç Fiyatı</span>
        <span className="text-sm font-semibold text-foreground">{influencer?.startingPrice}</span>
      </div>
      <Button
        variant="outline"
        size="sm"
        fullWidth
        iconName="ArrowRight"
        iconPosition="right"
        onClick={() => navigate(`/influencer-profile?id=${influencer?.id}`)}
      >
        Profili Görüntüle
      </Button>
    </div>
  );
};

export default RecommendedInfluencer;